import { DecimalPipe, NgStyle } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-faq-card',
  standalone: true,
  imports: [NgStyle, DecimalPipe],
  templateUrl: './faq-card.component.html',
  styleUrl: './faq-card.component.scss'
})
export class FaqCardComponent {
  @ViewChild('faqText') paragraphElem!: ElementRef;

  @Input() index!: number;
  @Input() question!: string;
  @Input() answer!: string;

  isOpen: boolean = false;
  openedStyle = {
    'opacity': 100,
    'transform': 'scale(1)',
    'transition': 'opacity .15s linear, margin-bottom .3s linear',
    'margin-bottom': '0'
  };
  closedStyle = {
    'opacity': 0,
    'transform': 'scale(1.5)',
    'transition': 'opacity .15s linear, transform .3s linear, margin-bottom .3s linear',
    'margin-bottom': '0'
  };
  btnOpenedStyle = {
    'transform': 'rotate(-360deg)',
    'opacity': '0',
    'transition': 'transform .3s linear, opacity .3s linear'
  };
  btnClosedStyle = {
    'transform': 'rotate(0)',
    'opacity': '100',
    'transition': 'opacity .15s linear'
  };
  closeBtnOpenedStyle = {
    'opacity': '100',
    'transform': 'scale3d(1, 1, 1)',
    'transition': 'opacity .3s linear'
  };
  closeBtnClosedStyle = {
    'opacity': '0',
    'transform': 'scale3d(0.5, 0.5, 0.5)',
    'transition': 'opacity .15s linear, transform .3s linear'
  };

  @HostListener('window:resize')
  onResize() {
    let elemHeight = this.paragraphElem.nativeElement.offsetHeight;
    this.closedStyle['margin-bottom'] = `-${elemHeight}px`;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let elemHeight = this.paragraphElem.nativeElement.offsetHeight;
      this.closedStyle['margin-bottom'] = `-${elemHeight}px`;
    }, 500)
  }

  changeState() {
    this.isOpen = !this.isOpen;
  }
}
